import * as React from 'react';

import muiStyles from './styles';
import { AttributeBadgeProps } from './types';

export default function AttributeBadge(props: AttributeBadgeProps) {
    const {
        className,
        value,
        active,
        testId
    } = props;

    const classes = muiStyles(props);

    const getClass = () => {
        switch (value.length) {
            case 1:
                return classes.singleValue;
            case 2:
                return classes.doubleValue;
            default:
                return classes.tripleValue;
        }
    };

    const symbolStyle = React.useMemo(() => getClass(), [value.length]);

    return (
        <span
            className={`${className} ${classes.value} ${symbolStyle} ${!active && classes.inactive}`}
            data-testid={testId ? testId : ''}
        >
            {value.length > 3 ? value.substring(0, 3) : value}
        </span>
    );
}